import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        display: flex;
        flex-direction: column;
        gap: 1em;
    }

    .container sl-button {
        width: 100%;
    }

    .footer {
        width: 100%;
        align-items: center;
        justify-content: center;
    }

    .button-bar {
        display: flex;
        justify-content: end;
        width: 100%;
        align-items: center;
    }

    sl-input {
        width: 100%;
    }

    ds-media {
        overflow: hidden;
    }

    sl-icon-button {
        font-size: 1.5em;
        margin-left: 0.3em;
        margin-right: 0.3em;
    }

    .drag-drop-target {
        align-items: center;
        justify-content: center;
    }

    .drag-drop-target .content {
        display: flex;
        width: 100%;
        background-color: var(--sl-panel-background-color);
        align-items: center;
        justify-content: center;
        min-height: 10em;
        border: darkgray solid 1px;
    }

    .drag-drop-target sl-button {
        width: 100%;
    }

    .import-view {
        height: 100%;
    }

    .error {
        font-weight: bold;
        color: red;
    }
`;
